import { render, staticRenderFns } from "./coursePriceSetting.vue?vue&type=template&id=52d9f2a6&"
import script from "./coursePriceSetting.vue?vue&type=script&lang=js&"
export * from "./coursePriceSetting.vue?vue&type=script&lang=js&"
import style0 from "./coursePriceSetting.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports